import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";
import createResolverFactory from "components/QueryClient/ResolverFactory";

export function useAccessListStatus(onDone = () => {}) {
  const mutationFactory = useCallback(() => {
    const query = `mutation updateAccessStatus($ids: [ID]!, $status: String!) {
      updateAccessStatus(ids: $ids, status: $status) {
        successMessage
      }
    }`;

    const resolver = ({ data: { updateAccessStatus } }) => {
      return {
        data: updateAccessStatus,
      };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const [mutation, { loading }] = useMutationWithToaster(mutationFactory, {
    onDone,
  });

  return {
    updateAccessStatus: (ids, status) => {
      return mutation(
        { ids, status },
        {
          defaultErrorMsg: "Failed to update access list status",
        }
      );
    },
    loading: loading,
  };
}

export default useAccessListStatus;
